import { useContext } from 'react';
import { LegalEntityContext } from 'common/context/legalEntity/legalEntity.context';

export const useLegalEntityContext = () => useContext(LegalEntityContext);
